import { render, staticRenderFns } from "./QrOrderBillSplit.vue?vue&type=template&id=5181e652&scoped=true&"
import script from "./QrOrderBillSplit.vue?vue&type=script&lang=js&"
export * from "./QrOrderBillSplit.vue?vue&type=script&lang=js&"
import style0 from "./QrOrderBillSplit.vue?vue&type=style&index=0&id=5181e652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181e652",
  null
  
)

export default component.exports